import apiUseCases from "@src/cloud-connect/api";
import { MachineWithSkills } from "@src/cloud-connect/api/client-configuration/get-machines-with-skills";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getMachineWithSkillsUseCase = async (
  machineId: string,
): Promise<{
  success: boolean;
  data?: MachineWithSkills;
  error?: string;
}> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const data = await apiUseCases.getMachineWithSkills(namespace, machineId);

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch machine skills.")
        .message,
    };
  }
};
